import axios from 'axios';
// import store from '../store/index'

let apiUrl = process.env.VUE_APP_API_URL;
let apiCancelSource = null;

export default {
    getHeaders() {
        return {
            cancelToken: apiCancelSource? apiCancelSource.token : null,
            // headers: {
                // 'user-serial': store.state.auth.user ? store.state.auth.user.serial : null,
                // 'panel': true,
            // }
        };
    },
    get(endpoint) {
        this.cancel();
        apiCancelSource = axios.CancelToken.source();

        return axios.get(apiUrl + endpoint, this.getHeaders())
            .then(
                response => response.data
            ).catch(function (error) {
                throw new Error(error);
            });
    },
    put(endpoint, payload) {
        this.cancel();
        apiCancelSource = axios.CancelToken.source();

        return axios.put(apiUrl + endpoint, payload, this.getHeaders())
            .then(
                response => response.data
            ).catch(function (error) {
                throw new Error(error);
            });
    },
    list(endpoint) {
        this.cancel();
        apiCancelSource = axios.CancelToken.source();

        return axios.get(apiUrl + endpoint, this.getHeaders())
            .then(
                response => response
            ).catch(function (error) {
                throw new Error(error);
            });
    },
    delete(endpoint) {
        return axios.delete(apiUrl + endpoint, this.getHeaders())
            .then(
                response => response.data
            ).catch(function (error) {
                throw new Error(error);
            });
    },
    cancel() {
        if (apiCancelSource)
            apiCancelSource.cancel('Cancel previous request');
    }
}
